const TransactionTable = ({ transactions }) => {
  if (transactions.length === 0) {
    return <p>Aucune transaction importée pour le moment.</p>;
  }

  return (
    <div>
      <h2>Transactions importées ({transactions.length})</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Date</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Description</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Montant</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Catégorie</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Catégorie Parente</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Fournisseur</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Compte</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index) => (
            <tr key={index}>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.date}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.description}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.amount}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.category}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.categoryParent}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.supplier}</td>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{transaction.account}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionTable;
